import { DxTradeOrder, DxTradeOrderStatuses, DxTradeOrderTypes } from '@model/DxTrade.types'

export type TradeProtectiveOrders = {
  stopLoss: number | null
  takeProfit: number | null
  stopLossOrderCode: string | null
  takeProfitOrderCode: string | null
  stopLossClientOrderId: string | null
  takeProfitClientOrderId: string | null
}

export const findTradeProtectiveOrders = (
  positionCode: string,
  orders?: DxTradeOrder[] | null
): TradeProtectiveOrders => {
  const workingOrders = (orders ?? []).filter(
    (order) => order.status === DxTradeOrderStatuses.WORKING
  )
  const relatedOrders = workingOrders.filter((order) =>
    order.legs?.some((leg) => leg.positionCode === positionCode)
  )

  let stopLoss: number | null = null
  let takeProfit: number | null = null
  let stopLossOrderCode: string | null = null
  let takeProfitOrderCode: string | null = null
  let stopLossClientOrderId: string | null = null
  let takeProfitClientOrderId: string | null = null

  for (const order of relatedOrders) {
    for (const leg of order.legs || []) {
      if (leg.positionCode !== positionCode) continue
      const price = leg.price
      if (price == null) continue

      if (order.type === DxTradeOrderTypes.STOP && stopLoss === null) {
        stopLoss = price
        stopLossOrderCode = order.orderCode ?? null
        stopLossClientOrderId = order.clientOrderId ?? null
      }

      if (order.type === DxTradeOrderTypes.LIMIT && takeProfit === null) {
        takeProfit = price
        takeProfitOrderCode = order.orderCode ?? null
        takeProfitClientOrderId = order.clientOrderId ?? null
      }
    }
  }

  return {
    stopLoss,
    takeProfit,
    stopLossOrderCode,
    takeProfitOrderCode,
    stopLossClientOrderId,
    takeProfitClientOrderId,
  }
}
